import React, { useState } from 'react';
import { handleADA } from '@dsg-tech/homefield-utils';
import { checkStores, setDataEmTag } from 'utility/utility';
import './DropdownNavSM.scss';
import { CTA, HeaderNavLinks } from 'types';
import { TextLink } from '@dsg-tech/homefield-react';

interface NavBarState {
  showNavBarMobileOpen: boolean;
  showSubMenu: boolean;
}

interface DropDownNavSMProps {
  readonly headerNavLinks?: HeaderNavLinks[];
}

export default function DropDownNavSM({ headerNavLinks = [] }: DropDownNavSMProps) {
  const [showSubMenu, setShowSubMenu] = useState<NavBarState['showSubMenu']>(false);

  const [currentHoverIndex, setCurrentHoverIndex] = useState<number>(-1);

  const handleMouseEnter = (index: number, link: HeaderNavLinks) => {
    // Handle when event is a KeyboardEvent
    if (link?.cta?.length === 0) {
      window.location.href = '/';
    }
    setCurrentHoverIndex(index);
    setShowSubMenu(true);
  };

  const handleKeyPress = (event: React.KeyboardEvent, index: number, link: HeaderNavLinks) => {
    handleADA(event, 'menuitem', () => handleMouseEnter(index, link));
  };

  return (
    <div
      className="rc-dropdown-menu hmf-display-none hmf-w-100 hmf-display-m-flex hmf-text-align-center"
      onMouseLeave={() => setShowSubMenu(false)}
      role="menubar"
      tabIndex={0}>
      {headerNavLinks.map((link: HeaderNavLinks, i: number) => (
        <div
          className="rc-dropdown-title hmf-display-xs hmf-m-xxxs"
          onMouseEnter={() => link?.cta?.length !== 0 && handleMouseEnter(i, link)}
          onKeyDown={(e) => link?.cta?.length !== 0 && handleKeyPress(e, i, link)}
          onFocus={() => link?.cta?.length !== 0 && handleMouseEnter(i, link)}
          onMouseLeave={() => setCurrentHoverIndex(-1)}
          tabIndex={0}
          aria-haspopup
          aria-expanded={showSubMenu && i === currentHoverIndex}
          aria-controls={`rc-subheader-dropdown-${i}`}
          role="menuitem"
          key={`${link.title}`}>
          <span tabIndex={-1}>{link.title}</span>
          <div
            className={`rc-subheader-dropdown rc-dropdown-links hmf-position-absolute ${
              showSubMenu && i === currentHoverIndex ? 'hmf-display-block' : 'hmf-display-none'
            }`}
            aria-hidden={!(showSubMenu && i === currentHoverIndex)}
            id={`rc-subheader-dropdown-${i}`}>
            <div className="hmf-display-flex hmf-justify-content-center">
              {link?.cta?.map((category: CTA) => (
                <TextLink
                  variant="secondary"
                  href={checkStores(category.link)}
                  data-em={setDataEmTag('TopNav', category.linkTitle)}
                  className="category-title-link hmf-ml-xl hmf-body-bold-l"
                  key={`${category.linkTitle}-${category.link}`}>
                  {category.linkTitle}
                </TextLink>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
